// Microsoft MSAL configuration — drives OAuth for MS Graph (Outlook + OneDrive).
//
// Setup (per README + spec/21-integrations.md):
// 1. Register an SPA app at https://entra.microsoft.com → App registrations.
// 2. Set redirect URI = http://localhost:5174 (matches our Vite dev port).
// 3. Add Microsoft Graph delegated permissions:
//      User.Read, Mail.Read, Mail.ReadWrite, offline_access.
//    NOTE: Mail.Read added so Jemma can READ the inbox (not just create drafts).
//    Mail.ReadWrite alone is *not* sufficient for /me/messages?$search — Graph
//    explicitly requires Mail.Read for read-only listing semantics. Both granted.
// 4. Copy the Application (client) ID + Directory (tenant) ID.
// 5. Paste into .env.local as VITE_MSAL_CLIENT_ID + VITE_MSAL_TENANT_ID.
//
// Tenant ID notes:
// - 'common' — accepts any work/school + personal accounts
// - 'organizations' — work/school only
// - '<your-tenant-guid>' — locks to KMF's tenant specifically (most secure for an internal tool)

import type { Configuration, PopupRequest } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_MSAL_CLIENT_ID ?? '';
const tenantId = import.meta.env.VITE_MSAL_TENANT_ID ?? 'common';

export const msalConfigured = clientId.length > 0;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5174',
    postLogoutRedirectUri:
      typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5174',
  },
  cache: {
    // localStorage so the session survives across browser tabs + refreshes.
    // For higher security at the cost of UX, switch to 'sessionStorage'.
    cacheLocation: 'localStorage',
  },
};

export const loginRequest: PopupRequest = {
  scopes: [
    'User.Read',         // basic profile (display name, email)
    'Mail.Read',         // read inbox + individual messages (Jemma "read my email" capability)
    'Mail.ReadWrite',    // create/read/update Outlook drafts (per feedback-drafts-never-autosend)
    'offline_access',    // refresh tokens — long-lived sessions
  ],
};
